import { userLogin } from "../api/AuthService";
import { verifyRegister, getRegisterOptions, getLoginOptions } from "../api/MFA";
import { success, failed }               from "../common/Toastify";
import { useDispatch } from "react-redux";
import { userlogin } from "../slice/authService";
import { applySessionAuth } from "../../utils/sessionAuth";

const base64UrlToBuffer = (base64Url) => {
  let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const pad = base64.length % 4;
  if (pad) base64 += "=".repeat(4 - pad);
  return Uint8Array.from(atob(base64), c => c.charCodeAt(0));
};

const bufferToBase64Url = (buffer) => {
    let b64 = btoa(String.fromCharCode(...new Uint8Array(buffer)));
    return b64
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, ""); 
  };

export const startRegistration = async (userId, orgId, passkeyName) => {
  try {
    const resp   = await getRegisterOptions(userId, orgId);
    const { data: options } = JSON.parse(resp.body);

    options.challenge = base64UrlToBuffer(options.challenge);

    options.user.id = new TextEncoder().encode(options.user.id);

    options.excludeCredentials = options.excludeCredentials.map(cred => ({
      ...cred,
      id: base64UrlToBuffer(cred.id),
    }));

    const credential = await navigator.credentials.create({ publicKey: options });

    if (!credential) { 
        failed("No credential returned from browser");
        return;
    }

    const attestation = {
      id:       credential.id,
      rawId:    bufferToBase64Url(credential.rawId),
      type:     credential.type,
      response: {
        clientDataJSON:    bufferToBase64Url(credential.response.clientDataJSON),
        attestationObject: bufferToBase64Url(credential.response.attestationObject),
      },
    };

    const result = await verifyRegister(userId, orgId, passkeyName ,attestation);
    const status = JSON.parse(result.body).status;
    status
      ? success("Passkey registered successfully")
      : failed(result?.message || "Registration failed");
    
    return status;


  } catch (err) {
    console.error(err);
    failed(err.message || "Error during registration");
    return false;
  }
};

export const startLogin = async (userId, orgId, username, password, dispatch) => {
  try {
    const resp = await getLoginOptions(userId, orgId);
    const { data: options } = JSON.parse(resp.body);

    options.challenge = base64UrlToBuffer(options.challenge);
    options.allowCredentials = options.allowCredentials.map(cred => ({
      ...cred,
      id: base64UrlToBuffer(cred.id),
    }));

    const assertion = await navigator.credentials.get({ publicKey: options });
    if (!assertion) {
      failed("No assertion returned from browser");
      return;
    }

    const authData = {
      id:       assertion.id,
      rawId:    bufferToBase64Url(assertion.rawId),
      type:     assertion.type,
      response: {
        clientDataJSON: bufferToBase64Url(assertion.response.clientDataJSON),
        authenticatorData: bufferToBase64Url(assertion.response.authenticatorData),
        signature: bufferToBase64Url(assertion.response.signature),
        userHandle: assertion.response.userHandle ? bufferToBase64Url(assertion.response.userHandle) : null,
      },
    };

    const data = {
      username: username,
      password: password,
      attestResp: authData,
    }

    const response = await userLogin(data);
    if (response.authType === "success") {
      success("Login successful");
      dispatch(userlogin(response.user));
      applySessionAuth(dispatch, {
        accessToken: response.token,
        refreshToken: response.refresh_token ?? response.refreshToken,
      });

    } else {
      failed(response.message || "Login failed");
      return false;
    }
    
    
  }catch (err) {
    console.error(err);
    failed(err.message || "Error during login");
  }
}
